/* unplugin-vue-components disabled */import { render } from "./hinova.vue?vue&type=template&id=343c8722&scoped=true"
const script = {}

import "./hinova.vue?vue&type=style&index=0&id=343c8722&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.9.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343c8722"]])

export default __exports__